import React from "react";
import { Row, Col } from "reactstrap";
import Tutorial from "../tutorial";
import withStyles from "isomorphic-style-loader/withStyles";
import s from "./styles.scss";
import {
  serviceCaller,
  withModals,
  ServiceCallerProps,
  ModalProps,
  withLoginRedirect,
} from "../../composition";
import { firebaseConnect, isLoaded, isEmpty } from "react-redux-firebase";
import { connect } from "react-redux";
import get from "lodash.get";
import firebase from "firebase/compat/app";
import App = firebase.app.App;
import * as commonActions from "../../../utils/actions/common";
import ITutorialVideo from "../../../types/services/ITutorialVideo";

const firebasePath: string = "tutorialVideos";
const nodeName: string = "tutorialVideos";

interface Props extends ServiceCallerProps, ModalProps {
  firebase: App;
  tutorialVideos: Array<ITutorialVideo>;
  hideSelection: () => void;
}

class AcademyComponent extends React.PureComponent<Props> {
  render() {
    return (
      <div className={s.mainContainer}>
        <Row>{this.buildTutorials()}</Row>
      </div>
    );
  }

  buildTutorials() {
    const tutorialVideos: Array<ITutorialVideo> = this.props.tutorialVideos;
    return tutorialVideos.map(tutorialVideo => (
      <Col className={s.element} xl={4} lg={6} xs={12} key={tutorialVideo.key}>
        <Tutorial
          title={tutorialVideo.title}
          mediaUrl={tutorialVideo.mediaUrl}
          description={tutorialVideo.description}
        ></Tutorial>
      </Col>
    ));
  }

  componentDidMount() {
    this.props.hideSelection();
    if (window) {
      window.scrollTo(0, 0);
    }
  }
}

const mapStateToProps = (state, _) => {
  const { firebase } = state;
  return {
    firebase: firebase,
    tutorialVideos:
      isLoaded(firebase.data[nodeName]) && !isEmpty(firebase.data[nodeName])
        ? get(firebase, `ordered.${nodeName}`, []).map(tutorialVideo => {
            const {
              mediaUrl,
              sortKey,
              title,
              description,
            } = tutorialVideo.value;
            return {
              mediaUrl,
              sortKey,
              title,
              key: tutorialVideo.key,
              description,
            };
          })
        : [],
  };
};

const mapDispatchToProps = dispatch => ({
  hideSelection: () => {
    dispatch(commonActions.hideSelection());
  },
});

export default serviceCaller(
  withLoginRedirect(
    connect(
      mapStateToProps,
      mapDispatchToProps
    )(
      withModals(
        firebaseConnect((_, store) => {
          return store.getState().user.currentCharity.id !== ""
            ? [
                {
                  path: firebasePath,
                  queryParams: ["orderByChild=sortKey"],
                },
              ]
            : [];
        })(withStyles(s)(AcademyComponent))
      )
    )
  )
);
